import React from 'react'

import { ComponentData } from '../table_component'

export const Text: React.FC<ComponentData> = ({ value }) => {
  return <div dangerouslySetInnerHTML={{ __html: value }}></div>
}
